/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Reminder_TrainingInputs */

const en_us2_profile_reminder_training = /** @type {(inputs: Profile_Reminder_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`on training days`)
};

const pt_br2_profile_reminder_training = /** @type {(inputs: Profile_Reminder_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nos dias de treino`)
};

const es_419_profile_reminder_training = /** @type {(inputs: Profile_Reminder_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`los días de entrenamiento`)
};

const pt_pt2_profile_reminder_training = /** @type {(inputs: Profile_Reminder_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nos dias de treino`)
};

const fr_fr2_profile_reminder_training = /** @type {(inputs: Profile_Reminder_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`les jours d'entraînement`)
};

const de_de2_profile_reminder_training = /** @type {(inputs: Profile_Reminder_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`an Trainingstagen`)
};

const it_it2_profile_reminder_training = /** @type {(inputs: Profile_Reminder_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nei giorni di allenamento`)
};

/**
* | output |
* | --- |
* | "on training days" |
*
* @param {Profile_Reminder_TrainingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_reminder_training = /** @type {((inputs?: Profile_Reminder_TrainingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Reminder_TrainingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_reminder_training(inputs)
	if (locale === "es-419") return es_419_profile_reminder_training(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_reminder_training(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_reminder_training(inputs)
	if (locale === "de-DE") return de_de2_profile_reminder_training(inputs)
	if (locale === "it-IT") return it_it2_profile_reminder_training(inputs)
	return en_us2_profile_reminder_training(inputs)
});
export { profile_reminder_training as "profile.reminder_training" }